import { toast } from 'react-toastify'

function showAlertNotification(message, success) {
  if (success) {            
    return toast.success(message);
  } else {
    return toast.error(message);
  }
}

function showAxiosErrorAlert(error) {
  let message = 'Something went wrong'

  if (typeof error === 'string') {
    message = error
  } else if (error?.response?.data?.message) {
    message = error.response.data.message
  } else if (error?.data?.message) {
    message = error.data.message
  } else if (error?.message) {
    message = error.message
  } else if (error?.response?.data && typeof error.response.data === 'string') {
    message = error.response.data
  } else if (error) {
    message = error.toString()
  }

  if (Array.isArray(message)) {
    message = message.join(', ')
  }

  toast.error(message)
}

const notification = {
  showAlertNotification,
  showAxiosErrorAlert
}

export default notification
